module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Row', {
    staticClass: "app"
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/img/logo-pantallas.png",
      "alt": "Pantallas"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "loginWrapper"
  }, [_c('i-form', {
    ref: "formValidate",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-position": "top"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Nombre de usuario",
      "prop": "username"
    }
  }, [_c('i-input', {
    attrs: {
      "size": "large",
      "autocomlpete": "off"
    },
    on: {
      "on-enter": function($event) {
        _vm.onSubmit('formValidate')
      }
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.form.username = $$v
      },
      expression: "form.username"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "person",
      "size": "18",
      "color": "#d1d1d2"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Contraseña",
      "prop": "password"
    }
  }, [_c('i-input', {
    attrs: {
      "type": "password",
      "size": "large",
      "autocomlpete": "off"
    },
    on: {
      "on-enter": function($event) {
        _vm.onSubmit('formValidate')
      }
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.form.password = $$v
      },
      expression: "form.password"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "locked",
      "size": "18",
      "color": "#d1d1d2"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('i-button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "long": "",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.onSubmit('formValidate')
      }
    }
  }, [_vm._v("Iniciar sesión")])], 1)], 1)]), _vm._v(" "), _c('i-col', {
    staticStyle: {
      "height": "100%",
      "position": "relative"
    },
    attrs: {
      "xs": 0,
      "md": 16
    }
  }, [_c('Carousel', {
    staticStyle: {
      "max-height": "100%"
    },
    attrs: {
      "dots": "none",
      "autoplay": true
    }
  }, [_c('Carousel-item', [_c('div', {
    staticStyle: {
      "background-image": "url('/static/img/malecon.jpg')"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('Carousel-item', [_c('div', {
    staticStyle: {
      "background-image": "url('/static/img/palacio-gobierno.jpg')"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('Carousel-item', [_c('div', {
    staticStyle: {
      "background-image": "url('/static/img/pantallas-carousel.jpg')"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('Carousel-item', [_c('div', {
    staticStyle: {
      "background-image": "url('/static/img/pantallas.jpg')"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('Carousel-item', [_c('div', {
    staticStyle: {
      "background-image": "url('/static/img/ventana-oficinas.jpg')"
    }
  }, [_vm._v(" ")])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "bottom": "0",
      "left": "0",
      "right": "0",
      "height": "150px",
      "background-color": "rgba(0,0,0,0.6)",
      "padding": "20px"
    }
  }, [_c('h1', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Bienvenido a pantallas,")]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("La mejor forma de administrar y distribuir tus contenidos")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee5433d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/login/Login.vue
// module id = 676
// module chunks = 1